import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

class UserRestClient extends RestClient {
  // GET /users/?email= — le back filtre par email, on renvoie le 1er résultat
  async retrieveByEmail({ email }) {
    const { results } = await this.list({ email });
    return results?.[0] ?? null;
  }

  // GET /users/is-from-measurement-agency/?agency_code= — la liste des agences
  async isFromMeasurementAgency({ agencyCode }) {
    const url = this.buildUrl("is-from-measurement-agency", {
      agency_code: agencyCode,
    });
    const response = await this.client.get(url);
    return this.toCamel(response.data).isFromMeasurementAgency;
  }
}

export const userRestClient = new UserRestClient(atmoClient, "users");
